var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApplicationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.42854 3H4.07142C3.78726 3 3.51474 3.11288 3.31381 3.31381C3.11288 3.51474 3 3.78726 3 4.07141V9.42848C3 9.71264 3.11288 9.98516 3.31381 10.1861C3.51474 10.387 3.78726 10.4999 4.07142 10.4999H9.42854C9.7127 10.4999 9.98522 10.387 10.1862 10.1861C10.3871 9.98516 10.5 9.71264 10.5 9.42848V4.07141C10.5 3.78726 10.3871 3.51474 10.1862 3.31381C9.98522 3.11288 9.7127 3 9.42854 3V3Z",
    stroke: "#065BA9",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.42854 13.5001H4.07142C3.78726 13.5001 3.51474 13.613 3.31381 13.8139C3.11288 14.0148 3 14.2873 3 14.5715V19.9286C3 20.2127 3.11288 20.4852 3.31381 20.6862C3.51474 20.8871 3.78726 21 4.07142 21H9.42854C9.7127 21 9.98522 20.8871 10.1862 20.6862C10.3871 20.4852 10.5 20.2127 10.5 19.9286V14.5715C10.5 14.2873 10.3871 14.0148 10.1862 13.8139C9.98522 13.613 9.7127 13.5001 9.42854 13.5001Z",
    stroke: "#065BA9",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9285 3H14.5714C14.2873 3 14.0147 3.11288 13.8138 3.31381C13.6129 3.51474 13.5 3.78726 13.5 4.07141V9.42848C13.5 9.71264 13.6129 9.98516 13.8138 10.1861C14.0147 10.387 14.2873 10.4999 14.5714 10.4999H19.9285C20.2127 10.4999 20.4852 10.387 20.6862 10.1861C20.8871 9.98516 21 9.71264 21 9.42848V4.07141C21 3.78726 20.8871 3.51474 20.6862 3.31381C20.4852 3.11288 20.2127 3 19.9285 3V3Z",
    stroke: "#065BA9",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9285 13.5001H14.5714C14.2873 13.5001 14.0147 13.613 13.8138 13.8139C13.6129 14.0148 13.5 14.2873 13.5 14.5715V19.9286C13.5 20.2127 13.6129 20.4852 13.8138 20.6862C14.0147 20.8871 14.2873 21 14.5714 21H19.9285C20.2127 21 20.4852 20.8871 20.6862 20.6862C20.8871 20.4852 21 20.2127 21 19.9286V14.5715C21 14.2873 20.8871 14.0148 20.6862 13.8139C20.4852 13.613 20.2127 13.5001 19.9285 13.5001Z",
    stroke: "#065BA9",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationIcon);
export default __webpack_public_path__ + "static/media/ApplicationIcon.328854c5c987c106c480bf883507092f.svg";
export { ForwardRef as ReactComponent };